import React from 'react';
import { Modal, Header, Button, Dimmer, Loader } from 'semantic-ui-react';
import AmsModal from '../../../utils/AmsModal';
import ActivityModalContent from './ActivityModalContent';

const ActivityModal = ({
  showActivityModal,
  closeModal,
  reportId,
  newReport,
  commentsFileList,
  renderFiles,
  activeItem,
  loading = false,
}) => {
  return (
    <AmsModal
      size="large"
      closeOnDimmerClick={false}
      onClose={closeModal}
      open={showActivityModal}
      className="ams-semantic-modal-fix"
    >
      <Header as="h2" content="Activity Dashboard" />

      <Modal.Content scrolling>
        {loading ? (
          <Dimmer active inverted>
            <Loader size="large">Loading activity...</Loader>
          </Dimmer>
        ) : (
          <ActivityModalContent
            reportId={reportId}
            newReport={newReport}
            commentsFileList={commentsFileList}
            renderFiles={renderFiles}
            activeItem={activeItem}
          />
        )}
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={closeModal} content="Close" primary />
      </Modal.Actions>
    </AmsModal>
  );
};

export default ActivityModal;
